export const ColumnFieldProp = Object.freeze({
    Options: 'options',
    Value: 'value',
});
